
<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Home',

    metaInfo: { title: 'Accueil' },

    extends: View,

    mixins: [
      LoadSections([
        'hero',
        'principes-fondateurs',
        // 'content',
        'missions',
        'conseil',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'home',
      },
    },
  }
</script>
